
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/confirm-buying-license/[type]",
      function () {
        return require("private-next-pages/terminal/confirm-buying-license/[type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/confirm-buying-license/[type]"])
      });
    }
  